module.exports = __webpack_public_path__ + "static/media/Component621.d9485732.svg";